import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Alert, Snackbar, Button, Box, Chip } from "@mui/material";
import { useFormik } from "formik";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";

import "./AddGroup.css";
import addimg from "../assets/addpicsvg.svg";
import {
  coachlist,
  playerlist,
  trainingroom,
  groupcreate,
  contenttypelist,
} from "../funtionsBD/Mainservice";
import { useNavigate } from "react-router-dom";
import { PlayerSelectionDialog } from "./PlayerSelectionDialog";
import { GroupKindFields } from "./GroupKindFields";
import {
  GroupJoinRulesFields,
  emptyJoinRulesForm,
  formToJoinRules,
} from "./GroupJoinRulesFields";
import { FfttClubImport } from "./FfttClubImport";
import { capForGroupKind } from "../../utils/groupKind";

export const AddGroup = ({ club }) => {
  const [pictures, setPictures] = useState();
  const [PLayers, setPlayers] = useState([]);
  const [Coach, setCoach] = useState([]);
  const [selectionRange, setSelectionRange] = useState(new Date());
  const [selectedtraining, setselectedtraining] = useState(null);
  const [selectedroom, setselectedroom] = useState();
  const [player, setplayer] = useState();
  const [coach, setcoach] = useState();
  const [trainingModes, setTrainingModes] = useState([]);
  const [numberOfTables, setNumberOfTables] = useState(1);
  const [joinRulesForm, setJoinRulesForm] = useState(emptyJoinRulesForm());

  const [success, setsuccess] = useState(false);
  const [error, seterror] = useState();
  const [open, setOpen] = useState(false);
  const [room, setroom] = useState();
  const [playerDialogOpen, setPlayerDialogOpen] = useState(false);

  const navigate = useNavigate();
  const [open2, setOpen2] = useState(false);
  const { t } = useTranslation();

  const info = JSON.parse(localStorage.getItem("user"));

  const formik = useFormik({
    initialValues: {
      name: "",
      des: "",
      club_id: "",
      kind: "training",
      guestCoachName: "",
    },
    // validate,
    onSubmit: (values, { resetForm }) => {
      handleadd(values, { resetForm });
    },
  });

  useEffect(() => {
    if (formik.values.club_id) {
      getroom(formik.values.club_id);
    }
  }, [formik.values.club_id]);

  useEffect(() => {
    loadTrainingModes();
  }, []);

  const loadTrainingModes = async () => {
    try {
      console.log("🔄 Loading training modes...");
      const response = await contenttypelist();
      console.log("📊 Training modes response:", response);
      if (response.data.status === "success") {
        const modes = response.data.data || [];
        console.log(`✅ Loaded ${modes.length} training modes:`, modes);
        setTrainingModes(modes);
      } else {
        console.error("❌ Error in response:", response.data);
        setTrainingModes([]);
      }
    } catch (error) {
      console.error("❌ Error loading training modes:", error);
      setTrainingModes([]);
    }
  };

  const getroom = async (id) => {
    try {
      const response = await trainingroom(id);
      console.log("Training rooms:", response);
      setroom(response.data.data);
      
      const response3 = await playerlist(id);
      console.log("Players response:", response3);
      console.log("Players data:", response3.data.data);
      const playersData = response3.data.data || [];
      console.log("Setting players:", playersData);
      setplayer(playersData);
      
      const response2 = await coachlist(id);
      console.log("Coaches:", response2);
      setcoach(response2.data.data);
    } catch (error) {
      console.error("Error loading data:", error);
      setplayer([]);
      setcoach([]);
      setroom([]);
    }
  };

  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const closealert2 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen2(false);
  };

  useEffect(() => {
    if (club[0]) {
      if (info.type_user_id === 1) {
        formik.setFieldValue("club_id", info.club_id);
      } else {
        const own = club.find((c) => c.club_id === info.club_id) || club[0];
        formik.setFieldValue("club_id", info.club_id || own?.club_id);
      }
    }
  }, [club]);

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    setPictures(file);
  };

  // ========================================================

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setCoach(typeof value === "string" ? value.split(",") : value);
  };

  const handleadd = async (values, { resetForm }) => {
    const cap = capForGroupKind(values.kind);
    if (cap && PLayers.length > cap) {
      seterror(t("groupKindCap", "At most {{cap}} players in this group.", { cap }));
      setOpen2(true);
      return;
    }
    try {
      const response = await groupcreate(
        pictures,
        {
          ...values,
          joinRules: formToJoinRules(joinRulesForm),
        },
        selectedtraining,
        Coach,
        PLayers,
        moment(selectionRange).format("YYYY-MM-DD"),
        selectedroom,
        numberOfTables
      );
      setsuccess(response.data.message);
      setOpen(true);
      setPictures();
      setCoach([]);
      setPlayers([]);
      setJoinRulesForm(emptyJoinRulesForm());
      resetForm();
      setSelectionRange(new Date());
      navigate("/GroupList");
    } catch (error) {
      console.log(error);
    }
  };
  console.log(formik.values);
  return (
    <form className="add-exercise group-form" onSubmit={formik.handleSubmit}>
      {pictures ? (
        <img
          className="uploaded-picture"
          src={URL.createObjectURL(pictures)}
          alt={`Profile img`}
        />
      ) : (
        <label htmlFor="profileimg">
          <div className="addimg_div">
            <img
              className="uploaded-picture"
              src={addimg}
              alt={`Profile img`}
            />
          </div>
        </label>
      )}

      <input
        className="input_addpicsvg"
        type="file"
        name="profileimg"
        id="profileimg"
        accept="image/*"
        onChange={handleFileInputChange}
      />
      <div className="input-details">
        {info.type_user_id !== 1 && (
          <div className="input-detail">
            <label htmlFor="">{t("selectclub")}</label>
            <select
              value={formik.values.club_id}
              onChange={formik.handleChange}
              name="club_id"
            >
              {club
                .filter((c) => !info.club_id || c.club_id === info.club_id)
                .map((t, index) => (
                <option key={index} value={t.club_id}>
                  {t.club_name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="input-detail">
          <label htmlFor="">{t("name")}</label>
          <input
            placeholder={t("writename")}
            type="text"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
          />
        </div>

        <div className="input-detail">
          <label htmlFor="">{t("description")}</label>
          <textarea
            placeholder={t("writegrp")}
            name="des"
            id=""
            cols="30"
            rows="5"
            value={formik.values.des}
            onChange={formik.handleChange}
          ></textarea>
        </div>
        <GroupKindFields
          kind={formik.values.kind}
          guestCoachName={formik.values.guestCoachName}
          onKind={(kind) => formik.setFieldValue("kind", kind)}
          onGuest={(name) => formik.setFieldValue("guestCoachName", name)}
        />
        <div className="input-detail group-join-rules-block">
          <label>
            {t("groupJoinRulesTitle", "Assignment rules")}
          </label>
          <GroupJoinRulesFields
            value={joinRulesForm}
            onChange={setJoinRulesForm}
          />
        </div>
        <FfttClubImport clubId={formik.values.club_id} />
        <div className="input-detail" style={{ marginTop: "20px" }}>
          <label htmlFor="no-of-sessions">{t("player")}</label>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => setPlayerDialogOpen(true)}
          >
            {PLayers.length === 0
              ? t("selectPlayers") || "Select players"
              : `${PLayers.length} ${PLayers.length === 1 ? t("player") : t("players")} ${t("selected") || "selected"}`}
          </Button>
          {PLayers.length > 0 && (
            <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {player
                .filter((p) => PLayers.includes(p.player_id || p.user_id))
                .map((p) => (
                  <Chip
                    key={p.player_id || p.user_id}
                    label={
                      p.user_first_name && p.user_last_name
                        ? `${p.user_first_name} ${p.user_last_name}`
                        : p.user_alias || "Unknown"
                    }
                    size="small"
                    onDelete={() => {
                      setPlayers(PLayers.filter((id) => id !== (p.player_id || p.user_id)));
                    }}
                  />
                ))}
            </Box>
          )}
        </div>

        <div className="input-detail">
          <label htmlFor="">{t("coach")}</label>
          <Select
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            multiple
            value={Coach}
            onChange={(e) =>
              setCoach(
                typeof e.target.value === "string"
                  ? e.target.value.split(",")
                  : e.target.value
              )
            }
            input={<OutlinedInput label={t("coach")} />}
            MenuProps={{ PaperProps: { className: "group-form-menu" } }}
          >
            {coach?.map((name) => (
              <MenuItem
                key={name.coach_id}
                value={name.coach_id}
                className="group-form__menu-item"
              >
                {name.user_first_name + " " + name.user_last_name}
              </MenuItem>
            ))}
          </Select>
        </div>

        <div className="input-detail">
          <label htmlFor="">{t("trainingroom")}</label>
          <Select
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            value={selectedroom}
            input={<OutlinedInput label={t("trainingroom")} />}
            MenuProps={{ PaperProps: { className: "group-form-menu" } }}
          >
            {room?.map((name) => (
              <MenuItem
                key={name.troom_id}
                value={name.troom_id}
                className="group-form__menu-item"
                onClick={() => {
                  setselectedroom(name.troom_id);
                }}
              >
                {name.troom_name}
              </MenuItem>
            ))}
          </Select>
        </div>

        <div className="input-detail">
          <label htmlFor="training-mode">{t("trainingMode") || "Training Session Mode"}</label>
          {trainingModes.length === 0 ? (
            <div className="group-form__hint">
              {t("loadingTrainingModes") || "Loading training modes..."}
            </div>
          ) : (
            <Select
              labelId="training-mode-label"
              id="training-mode"
              value={selectedtraining || ""}
              onChange={(e) => setselectedtraining(e.target.value || null)}
              displayEmpty
              input={<OutlinedInput label={t("trainingMode") || "Training Session Mode"} />}
              MenuProps={{ PaperProps: { className: "group-form-menu" } }}
            >
              <MenuItem value="" className="group-form__menu-item">
                <em>{t("selectTrainingMode") || "Select a training mode (optional)"}</em>
              </MenuItem>
              {trainingModes.map((mode) => (
                <MenuItem
                  key={mode.te_gen_mode_id}
                  value={mode.te_gen_mode_id}
                  className="group-form__menu-item"
                >
                  {mode.ts_gen_mode}
                </MenuItem>
              ))}
            </Select>
          )}
        </div>

        <div className="input-detail">
          <label htmlFor="number-of-tables">{t("numberOfTables") || "Number of Tables"}</label>
          <input
            id="number-of-tables"
            type="number"
            min="1"
            value={numberOfTables}
            onChange={(e) => setNumberOfTables(Math.max(1, parseInt(e.target.value) || 1))}
            placeholder={t("enterNumberOfTables") || "Enter number of tables"}
          />
        </div>

        <div className="input-detail">
          <button className="w-100" type="submit">
            {t("addgroup")}
          </button>
        </div>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={closealert}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={3000}
        onClose={closealert2}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      </Snackbar>
      
      {/* Player Selection Dialog */}
      <PlayerSelectionDialog
        open={playerDialogOpen}
        onClose={() => setPlayerDialogOpen(false)}
        players={player || []}
        selectedPlayers={PLayers}
        onSelectPlayers={(selected) => setPlayers(selected)}
        clubId={formik.values.club_id}
      />
    </form>
  );
};
